import type { LocaleResources } from '../types';

/**
 * Common UI string resources
 * Shared buttons, labels, messages across multiple UIs
 */
export const commonStr: LocaleResources['commonStr'] = {
  button: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    add: 'Add',
    edit: 'Edit',
    select: 'Select',
    close: 'Close',
    confirm: 'Confirm',
    refresh: 'Refresh',
    exit: 'Exit',
    doNotSave: "Don't Save",
    apply: 'Apply',
  },
  dict: {
    position: 'Position',
  },
  label: {
    all: 'All',
    none: 'None',
    search: 'Search',
    name: 'Name',
    description: 'Description',
    condition: 'Condition',
    reference: 'Reference',
  },
  message: {
    askDelete: '. Do you want to delete?',
    confirmDelete: 'Are you sure you want to delete?',
    deleted: 'Deleted successfully.',
    requireRestart: 'Bot restart required after stopping.',
    saved: 'Saved.',
    saveSettingFirst: 'Please save the changed settings first.',
    waitSaving: 'Saving. Please wait...',
    warningDeleteIndicator:
      'WARNING!!!! The following conditions that reference the indicator to be deleted will also be deleted.',
  },
  tooltip: {
    darkModeToggle: 'Toggle Dark Mode',
    settings: 'Settings',
  },
  positionButton: {
    enterableAmount: 'of enterable amount',
    autoAmountEnter: 'Additional enter',
    holdingAmount: 'of holding amount',
  },
  indicatorPicker: {
    title: 'Select Indicator',
  },
  bottomPanel: {
    tab: {
      order: 'Trade History',
      log: 'Log',
    },
    log: {
      no: 'No',
      message: 'Log',
      timestamp: 'Time',
    },
    tradeSummary: {
      started: 'Start',
      elapsed: 'Elapsed',
      seed: 'Seed',
      summaryType: 'Summary Type:',
      enterExit: 'Enter/Exit',
      positionEnd: 'Position End',
      mixed: 'Mixed',
      profit: 'Profit',
      tradeFee: 'Fee',
      netPnl: 'Net P/L',
      netRoe: 'Net ROE',
      position: 'Position',
      win: 'Win',
      lose: 'Lose',
      winRate: 'Win Rate',
      profitAmount: 'Profit Amt',
      lossAmount: 'Loss Amt',
      profitLossRatio: 'P/L Ratio',
      enter: 'Enter',
      exit: 'Exit',
      realizedNetPnl: 'Realized Net P/L',
    },
    orderHistory: {
      symbol: 'Symbol',
      startDate: 'Start Date',
      endDate: 'End Date',
      showSymbolOnChart: 'Show this symbol on chart',
      moveToTimeOnChart: 'Navigate to this time on chart',
    },
  },
  validation: {
    enterNumber: 'Please enter a number.',
    rangeNumber: 'Please enter a number between {min} and {max}.',
  },
};
